import { NotificationActions, NotificationsTypes } from './notification.store';
import { errors } from '../resources/messages';

export const SearchStoreDefinition = {
  state: {
    searchResults: [],
    searchParameters: {
      filter: {},
      order: {},
    },
    changes: 0,
    isPending: false,
  },
  mutations: {
    searchStartRequest(state) {
      state.isPending = true;
    },
    searchEndRequest(state) {
      state.isPending = false;
    },
    setSearchResults(state, results) {
      state.searchResults = results;
    },
    searchChange(state) {
      state.changes++;
    },
    setSearchOrder(state, order) {
      state.order = { ...order };
    },
    setSearchFilter(state, filter) {
      state.filter = { ...filter };
    }
  },
  getters: {},
  actions: {
    startSearch({ commit }) {
      commit(Mutations.startRq);
    },
    endSearchSuccess({ commit }, results) {
      commit(Mutations.endRq);
      commit(Mutations.setResults, results);
      commit(Mutations.change);
    },
    endSearchFail({ commit, dispatch }) {
      commit(Mutations.endRq);
      dispatch(NotificationActions.createNotification, { type: NotificationsTypes.error, message: errors.search.request });
    },
    changeSearchFilter({ commit }, filter) {
      commit(Mutations.setFilter, filter);
    },
    changeSearchOrder({ commit }, order) {
      commit(Mutations.setOrder, order);
    }
  },
};

export const SearchActions = {
  startSearch: 'startSearch',
  endSearchSuccess: 'endSearchSuccess',
  endSearchFail: 'endSearchFail',
  changeSearchFilter: 'changeSearchFilter',
  changeSearchOrder: 'changeSearchOrder',
};

const Mutations = {
  startRq: 'searchStartRequest',
  endRq: 'searchEndRequest',
  change: 'searchChange',
  setResults: 'setSearchResults',
  setOrder: 'setSearchOrder',
  setFilter: 'setSearchFilter',
};

